module.exports = __webpack_public_path__ + "static/media/BLACKALL TAMBO REGIONAL.ce50ec01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/BLACKALL TAMBO REGIONAL.svg
// module id = 523
// module chunks = 0